export const UserRoleMap = {
  LABEL_ADMIN: 'labelAdmin',
  RELEASE_COORDINATOR: 'releaseCoordinator',
  VIDEO_COORDINATOR: 'videoCoordinator',
  RELEASE_APPROVER: 'releaseApprover',
  VIDEO_APPROVER: 'videoApprover',
  REPORTER: 'reporter',
  INVENTORY_MANAGER: 'inventoryManager',
  // deprecated roles below
  OPS_ADMIN: 'opsAdmin',
  TECH_ADMIN: 'techAdmin',
  SUPPORT_ADMIN: 'supportAdmin',
  RELEASE_MANAGER: 'releaseManager',
  VIDEO_MANAGER: 'videoManager',
} as const;
